export const CHECKBOX_GROUP_SEARCH_FIELD_NAME = 'search'
